import React, { Component } from "react";
import { Button, Icon, Pagination } from "semantic-ui-react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import './styles.scss';
import {
    getInquiryDataList
} from "../../core/actions/inquiryDataAction";
import { getProjectEmployeeSort } from "../../core/actions/projectEmployeeSortAction";
import InquiryDataForm from '../../components/InquiryDataForm';
import { exportFileAction } from "../../core/actions/commonAction";
import TableDateCustom from '../../components/ProjectTableDate';
import TableDateBusiness from '../../components/ProjectTableBusiness';
import functionCommon from "../../core/common/function";
import DetailModal from '../../components/DetailModal';
import moment from 'moment';
import ApproveModal from "../../components/ApproveModal";
import ERModal from '../../components/ERModal';
import {deleteCheckExport, inquiryDataCheckExport} from "../../core/actions/checkExportInquiryAction";
import {commonConstants} from "../../core/constant/common.constants";


class InquiryData extends Component {
    constructor(props) {
        super(props);
        let _currentYear = new Date().getFullYear();
        let _currentMonth = new Date().getMonth() + 1;
        this.state = {
            currentYear: _currentYear,
            currentMonth:   _currentMonth < 10 ? '0' + _currentMonth : _currentMonth,
            inquiryData: {
                id: "",
                projectCode: "",
                projectName: ""
            },
            paramList: {
                isSearch: 0,
                employeeId: functionCommon.getInfoUser('employeeId'),
                month: _currentMonth < 10 ? '0' + _currentMonth : _currentMonth,
                year: _currentYear,
                projectId: "",
                sortBy: "createdDate-desc",
                projectBy: "projectName-asc",
                projectNewId: ""
            },
            tableProjectStructure: [
                {
                    label: 'labels.projectName',
                    type: 'projectName',
                    isClass: 'inquiry-first-col',
                    fixed: 'left',
                    width: 200
                },
                {
                    label: 'labels.projectCode',
                    type: 'projectCode',
                    fixed: 'left',
                    width: 100

                },
                {
                    label: 'labels.totalHours',
                    type: 'totalHours',
                    fixed: 'left',
                    width: 90
                },

            ],
            tableBusinessStructure: [
                {
                    label: 'labels.item',
                    type: 'item',
                    fixed: 'left'
                },
            ],
            projectId: "",
            data: [],
            dataBusinessTime: {},
            errorCode: "",
            exportDisabled: false,
            isProjectDefault: true,
            open: false,
            paramUpdate: {
                employeeId: functionCommon.getInfoUser('employeeId'),
                projectId: "",
                date: "",
                approverSort: 'lastName-ASC'
            }, 
            modalStyle: "", 
            exportParam: {
                fromDate: "",
                toDate:""
            },
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            approveDisable: false,
            approverList: [],
            loading: true,
            paramCheckExport: {
                employeeId: functionCommon.getInfoUser('employeeId'),
                month: _currentMonth < 10 ? '0' + _currentMonth : _currentMonth,
                year: _currentYear,
                dayFrom: "",
                dayTo: ""
            },
            isApprove: "",
            loadingApprove: false,
            checkExport: ""
        }
    }

    componentWillMount() {
        // Call API position-list, show list position
        this.props.getInquiryDataList(this.state.paramList);        
        this.props.getProjectEmployeeSort({
            employeeId: '',
            projectSort: 'projectCode-ASC',
            employeeSort: 'employeeCode-ASC',
            approverSort: 'lastName-ASC'
        });
    }

    componentWillReceiveProps(nextProps) {
        this.clearTableProjectStructure();
        let _projectData = nextProps.inquiryDataReducer.dataInquiry.project;
        let _totalOT = nextProps.inquiryDataReducer.dataInquiry.totalOtOfMonth;
        let data = nextProps.inquiryDataReducer.dataInquiry;
        let date = functionCommon.dateInMonth(this.state.paramList.month, this.state.paramList.year);
        let _approverList = nextProps.projectEmployeeSortReducer.dataProjectEmployeeSort.approver;
        const _isApprove = nextProps.checkExportInquiryReducer.isApprove;
        const _loadingApprove = nextProps.checkExportInquiryReducer.loading;

        this.setState({
            approverList: _approverList
        })

        if(data['totalHourByProjectCode']){
            let _totalHourByProjectCode = data['totalHourByProjectCode']
            for (var key in _totalHourByProjectCode) {
                data['workLog'].forEach(workLog => {
                    if(workLog.projectCode === key){
                        workLog["totalHours"] = this.fixDecimal(_totalHourByProjectCode[key]);
                    }
                });
            }
        }
        
        date.forEach(item => {
            this.setState(prevState => ({
                tableProjectStructure: prevState.tableProjectStructure.concat(
                    {
                        label: item.dateConvert,
                        type: "normalTime",
                        isClass: item.isSunOrSa ? 'sun-sat-class' : '',
                        isDate: true,
                        subType: "workLogDate",
                        isValueInArray: true,
                        checkValue: item.date,
                        day: item.day,
                        width: 70
                        
                    }
                )
            }));
            this.setState(prevState => ({
                tableBusinessStructure: prevState.tableBusinessStructure.concat(
                    {
                        label: item.dateConvert,
                        type: "normalTime",
                        isClass: item.isSunOrSa ? 'sun-sat-class' : '',
                        isDate: true,
                        subType: "workLogDate",
                        isValueInArray: true,
                        checkValue: item.date  
                    }
                )
            }));
        });
        
        // No data
        if (!data['workLog'] || (data['workLog'] && !data['workLog'][0]) || data.isApprove === 1) {
            this.setState({
                exportDisabled: true
            });
        } else {
            this.setState({
                exportDisabled: false
            });
        }

        if (nextProps.inquiryDataReducer.errorCode) {
            if (nextProps.inquiryDataReducer.errorCode === "018") {
                this.setState({
                    approveDisable: true
                })
            } else {
                this.setState({
                    approveDisable: false
                })
            }
            this.setState({
                errorCode: nextProps.inquiryDataReducer.errorCode,
            });
            setTimeout(
                function () {
                    this.setState({ errorCode: "" });
                    nextProps.inquiryDataReducer.errorCode = "";
                }.bind(this),
                2000
            );
        } else {
            this.setState({
                approveDisable: false
            })
        }
        
        this.setState({
            data: data['workLog'],
            dataBusinessTime: data['businessTime'],
            totalOTByDate: data['totalHourByDate'],
            totalAllProject: data['totalHourAllProjectCode'],
            projectData: _projectData,
            totalOT: _totalOT ? _totalOT : 0,
            listCheckStatus: data['listCheckStatus'],
            loading: false
        });

        this.setState({
            loadingApprove: _loadingApprove
        })

        if (_isApprove === commonConstants.UNAPPROVE) {
            this.setState({
                checkExport: "message.044"
            })
        } else {
            this.setState({
                checkExport: ""
            })
        }
        this.triggerMessage();
    }

    // Handle on change selectbox
    changeSelect = evt => {
        const name = evt.target.name;
        const value = evt.target.value;  
        switch (name) {
            case 'year':
                this.setState({
                    currentYear: value
                });
                break;
            case 'month':
                this.setState({
                    currentMonth: value
                });
                break;
              
            default:
                let arrValue = value.split("-");
                this.setState({
                    projectId: arrValue[0],
                    isProjectDefault: arrValue[1] === '1' ? true : false
                });
                break;
        }
    }

    //clear table structure
    clearTableProjectStructure = () => {
        this.setState({
            tableProjectStructure: [
                {
                    label: 'labels.projectName',
                    type: 'projectName',
                    isClass: 'inquiry-first-col',
                    fixed: 'left',
                    width: 200
                },
                {
                    label: 'labels.projectCode',
                    type: 'projectCode',
                    fixed: 'left',
                    width: 100
                },
                {
                    label: 'labels.totalHours',
                    type: 'totalHours',
                    fixed: 'left',
                    width: 90
                }
    
            ],
            tableBusinessStructure: [
                {
                    label: 'labels.item',
                    type: 'item',
                    fixed: 'left'
                }
            ]
        })
    }

    // Event when click btn Search
    async searchInquiryData() {
        const year = this.state.currentYear;
        const month = this.state.currentMonth;
        const _projectId = this.state.projectId;
        this.props.deleteCheckExport();
        await this.setState({
            paramList: {
                isSearch: 1,
                employeeId: functionCommon.getInfoUser('employeeId'),
                month: month,
                year: year,
                projectId: _projectId,
                sortBy:  "createdDate-desc",
                projectBy: "projectName-asc",
                projectNewId: ""
            },
            loading: true
        });
        
        return this.props.getInquiryDataList(this.state.paramList);
    }

    // Event when click btn Add
    async addProject() {
        const year = this.state.currentYear;
        const month = this.state.currentMonth;
        const _projectId = this.state.projectId;
        this.props.deleteCheckExport();
        await this.setState({
            paramList: {
                isSearch: 0,
                employeeId: functionCommon.getInfoUser('employeeId'),
                month: month,
                year: year,
                projectId: _projectId,
                sortBy:  "createdDate-desc",
                projectBy: "projectName-asc",
                projectNewId: _projectId
            },
        });
        
        return this.props.getInquiryDataList(this.state.paramList);
    }

    // Event when click table cell
    onCellClick = (val, projectId) => {
        if(val.isDate) {
            let date = val.checkValue;
            date = moment(date).format("YYYY-MM-DD")
            this.setState(prevState => ({
                paramUpdate: {
                    ...prevState.paramUpdate,
                    projectId: projectId,
                    date: date
                }
            }));
            this.show('tiny', 'update'); 
        }
    }

    // Popup event
    show = (size, modalStyle) => this.setState({ size, open: true, modalStyle: modalStyle })
    close = async() => {
        this.setState({ open: false, modalStyle: '' });
        await this.setState(prevState => ({
            paramList: {
                ...prevState.paramList,
                projectNewId: ""
            }
        }));
        return this.props.getInquiryDataList(this.state.paramList);
    }
    cancelModal = () => {
        this.setState({ open: false, modalStyle: '' });
    }

    openAproveModal = () => {
        this.show('tiny', 'approve'); 
    }

    openOTLeave = () => {
        this.show('tiny', 'otLeaveForm'); 
    }

    // Event when click btn Export
    inquiryDataExportAction = () => {
        if (!this.checkValidate()) return;
        let exportParam = {};
        let paramCheckExport = {};
        if (this.state.exportParam.fromDate !== '' && this.state.exportParam.toDate!== '') {
            paramCheckExport = {
                employeeId: this.state.paramList.employeeId,
                month: "",
                year: this.state.currentYear,
                dayFrom: moment(this.state.exportParam.fromDate, 'DDMMYYYY').format('YYYY-MM-DD'),
                dayTo: moment(this.state.exportParam.toDate, 'DDMMYYYY').format('YYYY-MM-DD')
            };
            exportParam = {
                employeeId: this.state.paramList.employeeId,
                month: "",
                year: this.state.currentYear,
                projectId: this.state.paramList.projectId,
                sortBy: this.state.paramList.sortBy,
                projectBy: this.state.paramList.projectBy,
                fromDate: moment(this.state.exportParam.fromDate, 'DDMMYYYY').format('YYYY-MM-DD'),
                toDate: moment(this.state.exportParam.toDate, 'DDMMYYYY').format('YYYY-MM-DD')
            };
        } else {
            paramCheckExport = {
                employeeId: this.state.paramList.employeeId,
                month: this.state.currentMonth,
                year: this.state.currentYear,
                dayFrom: "",
                dayTo: ""
            };
            exportParam = {
                employeeId: this.state.paramList.employeeId,
                month: this.state.currentMonth,
                year: this.state.currentYear,
                projectId: this.state.projectId,
                sortBy: this.state.paramList.sortBy,
                projectBy: this.state.paramList.projectBy
            };
        }

        this.props.inquiryDataCheckExport(paramCheckExport, exportParam)
    }

    fixDecimal = (val) => {
        return (functionCommon.isDecimal(val)) 
        ? Number(parseFloat(val).toFixed(2)) 
        : val
    }

    changeParamDate = evt => {
        const name = evt.name;
        const value = evt.value;
        this.setState(prevState => ({
            exportParam: {
                ...prevState.exportParam,
                [name]: value
            }
        }));
    }

     // Check validate form
    checkValidate = () => {
        let isValidate = false;
        let _formError = {};
        const { exportParam } = this.state;

        if (exportParam.fromDate !== '' && exportParam.toDate === '') {
            _formError['toDate'] = 'message.601';
            isValidate = false;
            this.isNotValid(_formError);
        } else if (exportParam.fromDate === '' && exportParam.toDate !== '') {
            _formError['fromDate'] = 'message.600';
            isValidate = false;
            this.isNotValid(_formError);
        } else if (exportParam.fromDate !== '' && exportParam.toDate !== '') {
            let toDate = new Date(moment(exportParam.toDate, 'DDMMYYYY').format('YYYY-MM-DD'));
            let fromDate = new Date(moment(exportParam.fromDate, 'DDMMYYYY').format('YYYY-MM-DD'));
            let differentTime = toDate.getTime() - fromDate.getTime();
            let differentDay = Math.round(differentTime / 1000 / 60 / 60 /24);
            if (differentDay < 0) {
                _formError['fromToDate'] = 'message.040';
                isValidate = false;
                this.isNotValid(_formError);
            } else if (differentDay > 30) {
                _formError['fromDate'] = 'message.038';
                isValidate = false;
                this.isNotValid(_formError);
            } else {
                isValidate = true;
                this.setState(prevState => ({
                    inputSubmit: {
                        ...prevState.inputSubmit,
                        formError: {}
                    }
                }));
            }
        } else {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        }
        return isValidate;
    }

    isNotValid = (_formError) => {
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: _formError
            }
        }));
    }
    
    // Handle on change autoComplete
    changeAutoComplete = evt => {
        const name = evt._name;
        const value = evt._value;
        const isDefault = evt._isDefault;
        this.setState({
            projectId: value,
            isProjectDefault: isDefault === 1 ? true : false
        });
    }

    triggerMessage = () => {
        setTimeout(() => {
            this.setState({
                checkExport: "",
            });
        }, 2000);
    };

    render() {
        const { t } = this.props;
        const {currentMonth, currentYear, projectData, totalOT, errorCode, isProjectDefault,
             size, open, paramUpdate, exportParam, approverList, loadingApprove, checkExport } = this.state;
        return (
            <div className="inquiry-data-form">
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = '/' }, 500)}>
                        {t("navigation.engineerHourRecord")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location = '/update-working-hour' }, 500)}>
                        {t("navigation.updateWorkingHour")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location = '/inquiry-data' }, 500)}>
                        {t("navigation.inquiryData")}
                    </span>
                </h2>
                <div className="list-actions">
                    <Button
                        primary
                        onClick={() => this.searchInquiryData()}
                    >
                        <Icon name="search" />
                        {t("button.search")}
                    </Button>
                    <Button
                        disabled={loadingApprove}
                        onClick={e => this.inquiryDataExportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.export")}
                    </Button>
                    <Button
                        disabled={this.state.approveDisable}
                        onClick={e => this.openAproveModal()}
                    >
                        <Icon name="send" />
                        {t("button.getApproval")}
                    </Button>
                    <Button onClick={e => this.openOTLeave()}>
                        <Icon name="file excel outline"/>{t("button.exportOTLeave")}
                    </Button>
                </div>
                <div className="error-message date-error-message">{t(checkExport)}</div>
                <InquiryDataForm
                    currentValueMonth={currentMonth}
                    currentValueYear={currentYear}
                    totalOT={this.fixDecimal(totalOT)}
                    changeSelect={input => this.changeSelect(input)}
                    projectDataValue={projectData}
                    projectDefault={isProjectDefault}
                    addProject={() => this.addProject()}
                    changeDate={input => this.changeParamDate(input)}
                    exportParam={exportParam}
                    isError={this.state.inputSubmit.formError}
                    projectValue={this.state.projectId}
                    changeAutoComplete={input => this.changeAutoComplete(input)}
                />
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <div className="table-responsive">
                    <TableDateCustom
                        tableStructure={this.state.tableProjectStructure}
                        dataList={this.state.data}
                        totalOTDate={this.state.totalOTByDate}
                        defaultSort={this.state.paramList.sortBy}
                        unSelectRow={this.state.unSelectRow}
                        isTotal={true}
                        totalAllProject={this.fixDecimal(this.state.totalAllProject)}
                        listCheckStatus={this.state.listCheckStatus}
                        onCellClick={(val, projectId) => this.onCellClick(val, projectId)}
                        maxHeight="345"
                        loading={this.state.loading}
                        disableLeave
                        width="1170"
                    />
                </div>
                <div className="table-responsive">
                    <TableDateBusiness
                        tableStructure={this.state.tableBusinessStructure}
                        dataList={this.state.dataBusinessTime}
                        listCheckStatus={this.state.listCheckStatus}
                    />
                </div>  
                {
                     this.state.modalStyle === 'update' ?      
                    <DetailModal 
                        size={size} 
                        open={open} 
                        handleClose={this.close}
                        handleCancel={this.cancelModal}
                        modalStyle={this.state.modalStyle}
                        param={paramUpdate}
                    /> : ''
                }
                {
                    this.state.modalStyle === 'approve' ?   
                    <ApproveModal 
                        size={size} 
                        open={open} 
                        modalStyle={this.state.modalStyle}
                        handleClose={this.close}
                        handleCancel={this.cancelModal}
                        initialDate={'01' + '-' + this.state.paramList.month + '-' + this.state.paramList.year}
                        employeeId={this.state.paramList.employeeId}
                        approverList={approverList}
                    /> : ''
                }
                {
                    this.state.modalStyle === 'otLeaveForm' ?   
                    <ERModal 
                        size={size} 
                        open={open} 
                        handleClose={this.cancelModal}
                        modalStyle={this.state.modalStyle}
                        onPage="inquiryData"
                        employeeId={this.state.paramList.employeeId}
                        currentValueMonth={currentMonth}
                        currentValueYear={currentYear}
                    /> : ''
                }
            </div>
        )
    }
}
const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    getInquiryDataList: opt => dispatch(getInquiryDataList(opt)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param)),
    getProjectEmployeeSort: opt => dispatch(getProjectEmployeeSort(opt)),
    inquiryDataCheckExport: (opt, paramExport) => dispatch(inquiryDataCheckExport(opt, paramExport)),
    deleteCheckExport: opt => dispatch(deleteCheckExport(opt))
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(InquiryData);
